export const formatDistrictNumber = (num) => Number(num || 0).toLocaleString('en').replace(',', ' ');

export const formatDistrictAreaKm2 = (area) => {
    const km2 = Math.round((area || 0) / 1000000);
    return `${formatDistrictNumber(km2)} km2`;
};

export const formatDistrictTurnover = (turnOver) => `${formatDistrictNumber(turnOver)} KKR`;

export const formatDistrictFrequencyAndVisitTime = (frequency, vistingTimeHours) =>
    `${frequency || 0} besök / ${vistingTimeHours || 0} h`;
